module.exports = __webpack_public_path__ + "fonts/SFUIText-Light.4875179d.woff2";